<template>
  <div class="fg-box scoreboard" v-if="current_match.status == -2">
    <div :class="['match-equation', {'add_player-of': (manOfMatch || manOfSeries)} ]" v-if="(matchStatusInfo || equation)">
        <div class="status" v-if="matchStatusInfo">{{matchStatusInfo}}</div>
        <div class="status" v-if="equation">{{equation}}</div>
        <div class="player-of_match" v-if="(manOfMatch || manOfSeries)">
          <div class="player_info" v-if="manOfMatch">
            Player of the Match:<div>{{manOfMatch.name}}</div>
          </div>
          <div class="player_info" v-if="manOfSeries">
            Player of the Series:<div>{{manOfSeries.name}}</div>
          </div>
        </div>
    </div>
    <no-list
      v-if="!(innings && innings.length)"
      toShow="custom_message"
      plainMsg="Scorecard is not available for this match"
    />
    <div class="fg-body" v-else>
      <div class="text" v-for="(inn, i_idx) in innings" :key="i_idx">
        <div class="team-name">
          <div class="team-a">
            <strong>{{ getTeamName(inn.Battingteam, inn.Number) }}</strong>
          </div>
          <div class="score">
            <strong>{{ inn.Total }}/{{inn.Wickets}}{{inn.Isdeclared ? ' d' : ''}} </strong>({{ inn.Overs }})
          </div>
        </div>
        <div class="table-responsive table-scoreboard points-table">
          <table class="table">
            <thead>
              <tr>
                <th
                  v-for="(col, bat_idx) in batCols"
                  :key="bat_idx"
                  :class="[
                    { num: col.isNumber },
                    { 'align-left': !col.isNumber },
                  ]"
                >
                  {{ col.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(plyr, plyr_idx) in inn.Batsmen" :key="plyr_idx">
                <td
                  v-for="(col, bat_idx) in batCols"
                  :key="bat_idx"
                  :class="[
                    { num: col.isNumber },
                    { 'align-left': !col.isNumber },
                    { 'wkt-taker': col.isHowOut },
                  ]"
                >
                  {{
                    col.isName
                      ? getPlayerName(inn.Battingteam, plyr[col.key], true)
                      : col.isNumber
                      ? numberValue(plyr[col.key])
                      : plyr[col.key]
                  }}
                </td>
              </tr>
              <tr class="extras">
                <td>Extras</td>
                <td class="align-right">
                  {{
                    countExtras(inn.Noballs, inn.Wides, inn.Byes, inn.Legbyes)
                  }}
                </td>
                <td class="align-left" colspan="5">
                  ( NB {{ inn.Noballs }}, WD {{ inn.Wides }}, B {{ inn.Byes }},
                  LB {{ inn.Legbyes }} )
                </td>
              </tr>
              <tr class="total-run">
                <td>Total Runs</td>
                <td class="align-right">{{ inn.Total }}</td>
                <td class="align-left" colspan="5">
                  ( {{ inn.Wickets }} wkts, {{ inn.Overs }} ov )
                </td>
              </tr>
              <tr class="wkt-fall" v-if="inn.FallofWickets && inn.FallofWickets.length">
                <td colspan="7">
                  <div class="tr-title">
                    Fall of wickets
                    <div>
                      <span
                        class="out-player"
                        v-for="(fow, fow_idx) in inn.FallofWickets"
                        :key="fow_idx"
                      >
                        <span>{{ fow.Score }}/{{ fow.Wicket_No }}</span>
                        <span class="player">
                          ( {{ getPlayerName(inn.Battingteam, fow.Batsman) }},
                          {{ fow.Overs }} ov )</span
                        >
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table-responsive table-scoreboard points-table" v-if="inn.Bowlers && inn.Bowlers.length">
          <table class="table">
            <thead>
              <tr>
                <th
                  v-for="(col, bat_idx) in bowlCols"
                  :key="bat_idx"
                  :class="[
                    { num: col.isNumber },
                    { 'align-left': !col.isNumber },
                  ]"
                >
                  {{ col.name }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(plyr, plyr_idx) in inn.Bowlers" :key="plyr_idx">
                <td
                  v-for="(col, bat_idx) in bowlCols"
                  :key="bat_idx"
                  :class="[
                    { num: col.isNumber },
                    { 'align-left': !col.isNumber },
                    { 'wkt-taker': col.isHowOut },
                  ]"
                >
                  {{
                    col.isName
                      ? getPlayerName(inn.Bowlingteam, plyr[col.key], false)
                      : col.isNumber
                      ? numberValue(plyr[col.key])
                      : plyr[col.key]
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <div class="fg-box scoreboard" v-else>
    <div class="table-responsive table-scoreboard points-table">
      <table class="table squad">
        <thead v-if="squads.thead && squads.thead.length">
          <tr
            v-for="(th, th_idx) in squads.thead"
            :key="th_idx"
          >
            <th class="text-center">{{th.t1}}</th>
            <th class="text-center">{{th.t2}}</th>
          </tr>
        </thead>
        <tbody v-if="squads.tbody && squads.tbody.length">
          <tr
            v-for="(tr, tr_idx) in squads.tbody"
            :key="tr_idx"
          >
            <td class="text-center">{{tr.t1}}</td>
            <td class="text-center">{{tr.t2}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { ordinal_suffix_of } from '../../../assets/js/common';
import NoList from "../../common/NoList";
export default {
  props: ["details", "current_match"],
  components: {
    NoList
  },
  data() {
    return {
      batCols: [
        { name: "Batters", key: "Batsman", isName: true },
        { name: "", key: "Howout_short", isHowOut: true },
        { name: "R", key: "Runs", isNumber: true },
        { name: "B", key: "Balls", isNumber: true },
        { name: "4s", key: "Fours", isNumber: true },
        { name: "6s", key: "Sixes", isNumber: true },
        { name: "S/R", key: "Strikerate", isNumber: true },
      ],
      bowlCols: [
        { name: "Bowlers", key: "Bowler", isName: true },
        { name: "O", key: "Overs", isNumber: true },
        { name: "M", key: "Maidens", isNumber: true },
        { name: "R", key: "Runs", isNumber: true },
        { name: "W", key: "Wickets", isNumber: true },
        { name: "NB", key: "Noballs", isNumber: true },
        { name: "WD", key: "Wides", isNumber: true },
        { name: "Econ", key: "Economyrate", isNumber: true },
      ]
    };
  },
  computed: {
    equation() {
      return (this.details.matchSummary && this.details.matchSummary.equation);
    },
    matchStatusInfo() {
      return (this.details.matchSummary && this.details.matchSummary.status);
    },
    manOfMatch() {
      return (this.details.matchSummary && this.details.matchSummary.man_of_match);
    },
    manOfSeries() {
      return (this.details.matchSummary && this.details.matchSummary.man_of_series);
    },
    innings() {
      return this.details.innList;
    },
    teams() {
      return this.details.teamList;
    },
    squads() {
      let teams = this.teams;
      let thead = [], tbody = [];
      
      if(teams && Object.keys(teams).length) {
        Object.values(teams).forEach((t, t_idx) => {
          let keyName = (t_idx == 0) ? 't1' : 't2';
          let {Name_Full, Players} = t;
          if(!thead[0]) { thead.push({}); } // new entry
          thead[0][keyName] = Name_Full; // update existing entry
  
          if(Players && Object.keys(Players).length) {
            Object.values(Players).forEach((p, p_idx) => {
              if(!tbody[p_idx]) { tbody.push({}); } // new entry
              tbody[p_idx][keyName] = this.getDisplayPlayerName(p, true); // update existing entry
            })
          }
        })
      }
      return {thead, tbody};
    }
  },
  methods: {
    getTeamName(tid, innNumber, shortName) {
      if (this.teams && this.teams[tid]) {
        let displayInn = "";
        if(innNumber && this.innings && this.innings.length > 2) {
          let inng = this.innings.findIndex(inn => inn.Number == innNumber);
          let inning_num = (inng+1) > 2 ? 2 : 1;
          displayInn = ` ${inning_num}${ordinal_suffix_of(inning_num)} innings`;
        }
        return (shortName
          ? this.teams[tid]["Name_Short"]
          : this.teams[tid]["Name_Full"]) + displayInn;
      } else {
        return "";
      }
    },
    getPlayerName(tid, pid, withBadge) {
      if (
        this.teams[tid] &&
        this.teams[tid]["Players"] &&
        this.teams[tid]["Players"][pid]
      ) {
        return this.getDisplayPlayerName(this.teams[tid]["Players"][pid], withBadge);
      } else {
        return "-";
      }
    },
    getDisplayPlayerName(player, withBadge) {
      let badge = "";
      if (withBadge) {
        if (player["Iscaptain"] && player["Iskeeper"]) {
          badge = " (c & wk)";
        } else if (player["Iscaptain"]) {
          badge = " (c)";
        } else if (player["Iskeeper"]) {
          badge = " (wk)";
        }
      }
      if(player["Name_Short"]) {
        return `${player["Name_Short"]}${badge}`;
      } else {
        return `${player["Name_Full"]}${badge}`;
      }
    },
    countExtras(nb, wd, b, lb) {
      return +nb + +wd + +b + +lb;
    },
    numberValue(val) {
      if (isNaN(val) || val == "") {
        return "-";
      } else {
        return val;
      }
    },
  },
};
</script>